import { createModel } from '@rematch/core';
import { RootModel } from './RootState';

type Position = 'right' | 'left';

function isPosition(input: string): input is Position {
    return (['right', 'left'] as const).includes(input as Position);
}

export type AspectRatio = '1' | '4/5' | '2/3';

type DiscountBadge = 'hidden' | 'text' | 'percentage';

export type UiState = {
    mode: 'hidden' | 'button' | 'menu' | 'full';
    position: Position;
    aspectRatio: AspectRatio;
    discountBadge: DiscountBadge;
};

const initialState: UiState = {
    mode: 'hidden',
    position: 'right',
    aspectRatio: '4/5',
    discountBadge: 'hidden'
};

export const uiState = createModel<RootModel>()({
    state: initialState,
    reducers: {
        setMode(state, mode: UiState['mode']) {
            return { ...state, mode };
        },
        setPosition(state, input: string) {
            const position = isPosition(input) ? input : 'right';
            return { ...state, position };
        },
        setAspectRatio(state, aspectRatio: AspectRatio) {
            return { ...state, aspectRatio };
        },
        setDiscountBadge(state, discountBadge: DiscountBadge) {
            return { ...state, discountBadge };
        }
    }
});
